module.exports = __webpack_public_path__ + "static/media/bytt-no-15.9baec9ca.mp3";